/**
 * @generated SignedSource<<a38c20b3df79e9a32e89807d67a3d742>>
 * @relayHash 93f071a13614e9b1cac311dde06f99b5
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

// @relayRequestID c699bfb84a21ff66c9f3ec0304f078aaf4311194166f6949aaaedb9e7e376aa7

import type { ConcreteRequest } from 'relay-runtime';
export type DataSecurityPolicyAction = "AI_ACCESS" | "ANONYMOUS_ACCESS" | "APP_ACCESS" | "APP_ACCESS_CONFIGURED" | "ATTACHMENT_DOWNLOAD" | "MCP_ACCESS" | "PAGE_EXPORT" | "PUBLIC_LINKS" | "%future added value";
export type useIsActionDisabledForWorkspaceQuery$variables = {
  action: DataSecurityPolicyAction;
};
export type useIsActionDisabledForWorkspaceQuery$data = {
  readonly dataSecurityPolicy: {
    readonly isActionEnabledForWorkspace: {
      readonly action: DataSecurityPolicyAction | null;
      readonly allowed: boolean | null;
    };
  } | null;
};
export type useIsActionDisabledForWorkspaceQuery = {
  response: useIsActionDisabledForWorkspaceQuery$data;
  variables: useIsActionDisabledForWorkspaceQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "action"
  }
],
v1 = [
  {
    "concreteType": "Confluence_dataSecurityPolicy",
    "kind": "LinkedField",
    "name": "dataSecurityPolicy",
    "plural": false,
    "selections": [
      {
        "args": [
          {
            "kind": "Variable",
            "name": "action",
            "variableName": "action"
          }
        ],
        "concreteType": "DataSecurityPolicyDecision",
        "kind": "LinkedField",
        "name": "isActionEnabledForWorkspace",
        "plural": false,
        "selections": [
          {
            "kind": "ScalarField",
            "name": "action"
          },
          {
            "kind": "ScalarField",
            "name": "allowed"
          }
        ]
      }
    ]
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "name": "useIsActionDisabledForWorkspaceQuery",
    "selections": (v1/*: any*/),
    "type": "Query"
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "useIsActionDisabledForWorkspaceQuery",
    "selections": (v1/*: any*/)
  },
  "params": {
    "cacheID": "93f071a13614e9b1cac311dde06f99b5",
    "id": "c699bfb84a21ff66c9f3ec0304f078aaf4311194166f6949aaaedb9e7e376aa7",
    "metadata": {},
    "name": "useIsActionDisabledForWorkspaceQuery",
    "operationKind": "query",
    "text": "query useIsActionDisabledForWorkspaceQuery($action:DataSecurityPolicyAction!){dataSecurityPolicy{isActionEnabledForWorkspace(action:$action){action,allowed}}}"
  }
};
})();

(node as any).hash = "5548aa746f7031f0532e6507c978135c";

export default node;
